import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { useRef, useState } from 'react';
import { postAllData } from '../../service/ProductService';
import { SCRUTINY_VERIFICATION_UPDATE } from '../../config/ApiConstant';
import { VerificationDateValidation } from '../../config/Validate';
import { Calendar } from 'primereact/calendar';
import { convertDateFrom } from '../../appconfig/Settings';

const ScrutinyVerificationdateModal = (props: any) => {
    const toast = useRef<any>(null);

    const [holdBtnSpinner, setHoldBtnSpinner] = useState<boolean>(false);
    const [errors, setErrors] = useState<any>({});
    const [date, setDate] = useState<any>(new Date());

    // handle change date
    const handleChangeDate = (val: any) => {
        setDate(val);
    };

    const addVerificationDate = async () => {
        try {
            const { isError, errors } = VerificationDateValidation(date);
            setErrors(errors);
            if (!isError) {
                setHoldBtnSpinner(true);

                // Request Data
                let requestData = {
                    verification_date: convertDateFrom(date),
                    id: props.dateId
                };
                // Api Call
                const response = await postAllData(SCRUTINY_VERIFICATION_UPDATE, requestData);

                if (response) {
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                    setHoldBtnSpinner(false);
                    props.dismissClick();
                    setDate(new Date());
                }
            }
        } catch (error: any) {
            if (error.response) {
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
                setHoldBtnSpinner(false);
                props.dismissClick();
                setDate(new Date());
            }
        }
    };

    return (
        <>
            <Toast ref={toast} />

            <Dialog
                visible={props.openmodel}
                className="p-fluid"
                style={{ width: '500px' }}
                header="Verification"
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={() => props.dismissClick()} />
                        <Button label="Submit" icon="pi pi-check"  onClick={() => addVerificationDate()} loading={holdBtnSpinner} />
                    </>
                }
                onHide={() => props.dismissClick()}
            >
                <div className="field col-12 md:col-12">
                    <label htmlFor="date">
                        Date <span style={{ color: 'red' }}>*</span>
                    </label>
                    <div className="input-effect-div">
                        <Calendar
                            value={date}
                            dateFormat="dd MM yy"
                            onChange={(e: any) => {
                                handleChangeDate(e.value);
                            }}
                            showIcon
                        />
                        <small className="p-invalid-txt">{errors['VerificationDate']}</small>
                    </div>
                </div>
            </Dialog>
        </>
    );
};
export default ScrutinyVerificationdateModal;
